import { variant, fields } from 'variant';
import type { VariantOf, TypeNames } from 'variant';
import type { Site } from '@wix/site-list-client';

export const SiteState = variant({
  NotConfigured: {},
  NotFound: fields<{ id: string }>(),
  Resolved: fields<{ site: Site }>(),
});

export type SiteState<T extends TypeNames<typeof SiteState> = undefined> =
  VariantOf<typeof SiteState, T>;
